import React from 'react';
import PropTypes from 'prop-types';

import Popover from 'components/popover';
import ReleasePlaylistMenu from 'components/ReleaseOptions/ReleasePlaylistMenu';


/**
 * @desc Release Song options dropdown component
 * @memberof components/releaseDetails
 *
 * @param  {Object} track              				[Track for which the menu is rendered]
 * @param  {[Playlist]} playlists                   [List of available playlists]
 *
 * @param  {Function} onToggle               		[Dropdown toggle handler]
 * @param  {Function} onPlayNextClick               ['Play next' option click handler]
 * @param  {Function} onPlayLaterClick              ['Play later' option click handler]
 * @param  {Function} onCreatePlaylist         		['Create playlist' option click handler]
 * @param  {Function} onAddTrackToPlaylist          [Playlist to add selection handler]
 *
 * @type {Component}
 */
export default class ReleaseSongOptions extends React.PureComponent {
	static propTypes = {
		song: PropTypes.object,
		playlists: PropTypes.arrayOf(PropTypes.object),

		onToggle: PropTypes.func,
		onPlayNextClick: PropTypes.func.isRequired,
		onPlayLaterClick: PropTypes.func.isRequired,
		onCreatePlaylist: PropTypes.func.isRequired,
		onAddTrackToPlaylist: PropTypes.func.isRequired
	}

	/* Event Handlers */

	handlePlayNextClick = () => {
		const { song, onToggle, onPlayNextClick } = this.props;
		onToggle();

		return onPlayNextClick(song);
	}

	handlePlayLaterClick = () => {
		const { song, onToggle, onPlayLaterClick } = this.props;
		onToggle();

		return onPlayLaterClick(song);
	}

	handlePlaylistClick = (playlist) => {
		const { song, onToggle, onAddTrackToPlaylist } = this.props;

		onAddTrackToPlaylist(playlist, song);
		onToggle();
	}

	handleCreatePlaylistClick = (e) => {
		e.stopPropagation();
		const { song, onToggle, onCreatePlaylist } = this.props;

		onToggle();
		onCreatePlaylist(song);
	}

	/* Rendering */

	render() {
		// Destructure to remove extraneous props from ...rest
		const {
			song,
			playlists,
			onPlayNextClick,
			onPlayLaterClick,
			...rest
		} = this.props;

		return (
			<Popover onToggle={this.handleToggle} {...rest}>
				<ReleasePlaylistMenu
					playlists={playlists}
					onPlaylistClick={this.handlePlaylistClick}
					onPlayNextClick={this.handlePlayNextClick}
					onPlayLaterClick={this.handlePlayLaterClick}
					onCreatePlaylistClick={this.handleCreatePlaylistClick} />
			</Popover>
		);
	}
}
